import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';

import APIError from 'common/components/apiError/SidecartAPIError';
import { getCart } from 'redux/cart/actions';

import Content from './sideCart/Content';
import Title from './sideCart/Title';
import UserTools from './sideCart/UserTools';
import Wrapper from './sideCart/Wrapper';

const SideCartWidget = () => {
  const dispatch = useDispatch();

  const cartReducer = useSelector((state) => state.cart);
  const { data, isObjectFetching } = cartReducer;

  useEffect(() => {
    if (!isObjectFetching && !data) {
      dispatch(getCart());
    }
  }, [dispatch]);

  if (!data) {
    return null;
  }

  return ReactDOM.createPortal(
    <>
      <div className="c7-user-nav__cart">
        <UserTools />
        <Wrapper>
          <Title />
          <APIError />
          <Content />
        </Wrapper>
      </div>
    </>,
    document.getElementById('c7-cart')
  );
};

export default SideCartWidget;
